// Builds SVG polygon points for a star with varied outer radii and uniform inner corners
export const buildStarPoints = (
  outerRadii: number[],
  innerRadius: number,
): string =>
  outerRadii
    .flatMap((R, i) => {
      // Tip angle: start at -90° (top), step 30° per point
      const tip = ((-90 + i * 30) * Math.PI) / 180;

      // Inner corner sits halfway between this tip and the next
      const inner = ((-90 + i * 30 + 15) * Math.PI) / 180;

      return [
        `${(R * Math.cos(tip)).toFixed(1)},${(R * Math.sin(tip)).toFixed(1)}`,
        `${(innerRadius * Math.cos(inner)).toFixed(1)},${(innerRadius * Math.sin(inner)).toFixed(1)}`,
      ];
    })
    .join(' ');
